import { Alert, Button, DialogContentText, Stack } from '@mui/material';
import { useState } from 'react';
import { closeBrowserNotificationPermissionDialog } from '../../state/notifications/browser-notification-permission';
import { showNotification } from '../../state/notifications/notifications';

export const BrowserNotificationTest = () => {
  const [result, setResult] = useState<'idle' | 'asking' | 'missing'>('idle');

  const testNotifications = () => {
    showNotification({
      inAppText: 'Your test notification arrived.',
      browserNotificationText: 'Your test notification arrived.',
      status: 'success',
    });
    setResult('asking');
  };

  const confirmNotifications = () => {
    closeBrowserNotificationPermissionDialog();
    showNotification({ inAppText: 'Perfect, notifications are ready! 🎉', status: 'success', inAppExpiry: 'short' });
  };

  return (
    <Stack spacing={2} sx={{ alignItems: 'center', textAlign: 'center' }}>
      <Button variant="contained" onClick={testNotifications}>
        Test Notifications Now
      </Button>
      {result === 'asking' && (
        <>
          <DialogContentText>Did both the in-app and browser notifications appear?</DialogContentText>
          <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button onClick={confirmNotifications}>Yes, both appeared</Button>
            <Button onClick={() => setResult('missing')}>No browser notification</Button>
          </Stack>
        </>
      )}
      {result === 'missing' && (
        <Alert severity="warning" role="status">
          Your OS may be blocking notifications. Allow notifications for your browser in OS settings, check Do Not Disturb, then test again.
        </Alert>
      )}
    </Stack>
  );
};
